module.exports = __webpack_public_path__ + "static/media/cardTwo.615b0e5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowOne/cardTwo.jpg
// module id = 56
// module chunks = 0